export default __webpack_public_path__ + "static/media/5.d0c9f018.jpg";